// extracted by mini-css-extract-plugin
export default {"customLink":"CustomLink_customLink__w+jif"};